import { FormField, TextArea } from "@justworkshr/milo-form";
import { ChangeEventHandler, FocusEventHandler } from "react";
import { useTranslation } from "react-i18next";

type ClientBusinessDescriptionFieldProps = {
  name: string;
  value?: string;
  error?: string;
  handleBlur?: FocusEventHandler<HTMLTextAreaElement>;
  handleChange?: ChangeEventHandler<HTMLTextAreaElement>;
  required?: boolean;
};

export default function ClientBusinessDescriptionField({
  value,
  error,
  name,
  handleBlur,
  handleChange,
  required,
}: ClientBusinessDescriptionFieldProps) {
  const { t } = useTranslation();

  return (
    <FormField
      required={required}
      name={name}
      label={t("Client Business Description")}
      error={error}
      message={t(
        `Please provide a brief description of your business. This will be included in the employee’s agreement.`
      )}
    >
      <TextArea
        required={required}
        name={name}
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
      />
    </FormField>
  );
}
